import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Flex from "@components/ui-components/flex";
import FooterDataTable from "@components/datatable/footer-datatable";
import { LoaderOverlay } from "@components/spinner";
import PaginationDataTable from "@components/datatable";
import { getPlural } from "@helpers/utils";
import size from "lodash/size";
import { useTranslation } from "react-i18next";

const DataTableView = props => {
    
    const {
        actionItems = null,
        moduleName = "",
        tableProps,
        breadcrumbItems = {},
        title = "",
        desc = "",
        loading = false
    } = props;
    const { t } = useTranslation();
    
    return (
        <>
            {size(breadcrumbItems) ? (
                <Breadcrumbs
                    items={breadcrumbItems.items}
                    rightChildren={
                        <>
                            {breadcrumbItems.rightChildren}
                        </>
                    }/>
            ) : null}

            <Flex justify="between" align="center" className="mb-75 ps-25 flex-wrap">
                <Flex column>
                    {moduleName ? (
                        <div className="font-medium-2 fw-bolder" data-cy={`title-${moduleName}`}>
                            {t("All")} {t(moduleName)}:{" "}
                            {loading ? "-" : size(tableProps.pagination) ? tableProps.pagination.count : size(tableProps.data || [])}{" "}
                            {t(getPlural({ text: "Record", length: size(tableProps.pagination) ? tableProps.pagination.count : size(tableProps.data || []) }))}
                        </div>
                    ) : (
                        <div className="font-medium-2 fw-bolder">{t(title)}</div>
                    )}
                    {desc ? <small className="text-muted">{desc}</small> : null}
                </Flex>
                {actionItems}
            </Flex>
            <LoaderOverlay
                active={loading}
                children={
                    tableProps?.footer ? (
                        <FooterDataTable {...tableProps} loading={loading} />
                    ) : (
                        <PaginationDataTable {...tableProps} loading={loading} />
                    )
                }/>
        </>
    );
};
export default DataTableView;